import { render, staticRenderFns } from "./RoomInstance.vue?vue&type=template&id=11ff6ef4&scoped=true"
import script from "./RoomInstance.vue?vue&type=script&lang=js"
export * from "./RoomInstance.vue?vue&type=script&lang=js"
import style0 from "./RoomInstance.vue?vue&type=style&index=0&id=11ff6ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff6ef4",
  null
  
)

export default component.exports